export const STORAGE_BASE_API = '/storage';
export const STORAGE_STRUCTURE_API = '/storage/structure';
export const STORAGE_GENERAL_PARTNER_API = '/storage/structure/general-partner';
export const STORAGE_ASSETS_API = '/storage/assets';
export const STORAGE_INVESTORS_API = '/storage/investors';
export const STORAGE_ASSET_MANAGEMENT_API = '/storage/asset-management';
export const STORAGE_SERVICE_PROVIDERS_API = '/storage/service-providers';
